import { Vue, Options } from 'vue-class-component';
import {
  PlantDTO,
  ServerModel,
} from '@/../client-generator/generated-clients/plants';
import { getRoomIconFromType } from '@/core/utils/utils';
import { DefaultRoomDTO } from '@/../client-generator/generated-clients/configurations';

import NumberButtons from '@/views/components/NumberButtons/NumberButtons.vue';
import { mapGetters } from 'vuex';

@Options({
  name: 'DialogPlantCreateStep2',
  props: {
    plant: {
      required: true,
      type: Object as () => PlantDTO,
    },
  },
  computed: {
    ...mapGetters('UI', ['plantServerUseMHS1Only']),
  },
  components: {
    NumberButtons,
  },
  emits: ['is-loading'],
})
export default class DialogPlantCreateStep2 extends Vue {
  plant!: PlantDTO;
  ServerModel = ServerModel;
  roomTypes: DefaultRoomDTO[] = [];
  getRoomIcon = getRoomIconFromType;
  private readonly plantServerUseMHS1Only!: boolean;

  get plantServerImages() {
    return [
      {
        imageURLs: [
          require('@/assets/images/plants/server/ImagesMX-300EOS.png'),
        ],
        value: ServerModel.Classe300EOS,
      },
      {
        imageURLs: [require('@/assets/images/plants/server/ImagesMHS1.png')],
        value: ServerModel.MyHomeServer1,
      },
    ].filter((x) =>
      this.plantServerUseMHS1Only ? x.value === ServerModel.MyHomeServer1 : true
    );
  }

  async created() {}

  updatePlantRoom(room: DefaultRoomDTO) {
    const plantRoom = this.plant.roomsCounts?.find(
      (rc) => rc.type === room.type
    );

    if (!plantRoom) {
      console.log('Plant room not found');
      return;
    }

    plantRoom.count = room.count;
  }
}
